export const DEFAULT_NON_FACE_TO_FACE_MINUTES = 6;
export const DEFAULT_CUSTOMER_AVATAR = 14;
export const ID_OTHER_CUSTOMER_SOURCE = 10015;
